import { useEffect, useRef, useState } from 'react'

interface UseSimpleTextareaClassNameProps {
  rows?: number
  initialHeight?: number
}

export function useSimpleTextareaClassName({
  rows = 1,
  initialHeight
}: UseSimpleTextareaClassNameProps) {
  const getHeightClass = (height: number) => {
    const clampedHeight = Math.max(1, Math.min(100, Math.round(height)))
    return `h-${clampedHeight}px`
  }

  const initialHeightPx = initialHeight || rows * 20 + 20 // 20px is the padding of the textarea
  const [className, setClassName] = useState(() => getHeightClass(initialHeightPx))
  const ref = useRef<HTMLTextAreaElement | null>(null)

  useEffect(() => {
    const observer = new MutationObserver(() => {
      if (ref.current) {
        const cssText = ref.current.style.cssText
        if (cssText.includes('height')) {
          requestAnimationFrame(() => setClassName(''))
        }
      }
    })

    if (ref.current) {
      observer.observe(ref.current, {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true
      })
    }

    return () => observer.disconnect()
  }, [ref.current])

  return { className, ref } as const
}
